import PageComponent from '@/components/list/index';

export default PageComponent;
